(function()
{
	var Enum = include('springroll.Enum');
	var Debug = include('springroll.Debug');

	/**
	 * @param {String} str
	 * @param {springroll.Enum} Enum (Must be caps because of a keyword
	 */
	namespace('nature.enum').stringToEnum = function(str, Enum)
	{
		if (typeof str == 'string')
		{
			str = str.toLowerCase();

			for (var key in Enum)
			{
				if (Enum[key].name.toLowerCase() === str)
				{
					return Enum[key];
				}
			}
		}
		// An enum was sent through as the first param, just return it
		return str;
	};

	namespace('nature.enum').Powerup = new Enum(
		'Boost',
		'Hal',
		'Invulnerable',
		'Life',
		'Shield'
	);

	namespace('nature.enum').Mode = new Enum(
		'Entering',
		'Riding',
		'Exiting',
		'Tweening',
		'Dead',
		'Floating',
		'BeingCaught'
	);

	namespace('nature.enum').Task = new Enum(
		'Breath',
		'Instructions',
		'Fly',
		'WaitForTop',
		'Leaves',
		'RepeatLeaves',
		'RepeatBreeze',
		'Powerups',
		'Breeze',
		'Complete'
	);
}());
